import React, { useEffect, useState } from 'react';
import styles from '../news-tab/NewsTab.module.scss';
import { useGetQuery } from '../../../../../../services/apiCall';
import NewsCard from '../../../../../atoms/newsCard/NewsCard';
import endpoints from '../../../../../../api/endpoints';
import Text from '../../../../../atoms/text/Text';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../atoms/loader/Loader';
import useIsRtl from '../../../../../../app/helpers/isRtl';

const MediaTab = () => {
  const navigate = useNavigate();
  const isRtl = useIsRtl();

  const apiUrl = endpoints.news.mediaGallery;
  const { data, error, isLoading } = useGetQuery({ apiUrl });

  const [delayDone, setDelayDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDelayDone(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={styles['cards-container']}>
      {!delayDone || isLoading ? (
        <div className={styles['loader-container']}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={styles.cards} dir={isRtl ? 'rtl' : ''}>
            {data?.slice(0, 4)?.map((gallery) => {
              const firstImage = gallery.images[0];
              return (
                <NewsCard
                  key={gallery?.mediaGalleryId}
                  id={gallery?.mediaGalleryId}
                  image={
                    firstImage
                      ? `${firstImage?.url}${firstImage?.imageURL}`
                      : ''
                  }
                  gallery={gallery}
                  title={gallery?.galleryName_AR}
                  description={null}
                  type="media"
                  isCLickable
                  className={styles.card}
                />
              );
            })}
          </div>
          <div className={styles['view-container']}>
            <button
              className={styles['view-btn']}
              onClick={() => navigate('/news-and-events/media')}
            >
              <Text
                title="common.view_all"
                variant="text-bold-italic-16"
                maxLines={2}
                className={styles.btnTitle}
              />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MediaTab;
